<template>
  <div class="content">
    <top-header
      v-if="!isWx"
      :type="6"
      :placeholder="lsName"
      textColor="#000"
      bgColor="#fff"
      fontSize="0.32rem"
    />
    <div v-html="lsInfo"></div>
  </div>
</template>
<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      lsInfo: "",
      lsName: "",
      isWx: this.$route.query.wx || false,
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.$http
        .post(
          "house/zxgw/zxjgInfo.do",
          qs.stringify({
            type: 0,
          })
        )
        .then((res) => {
          this.lsInfo = res.obj[0].organIntroduce;
          this.lsName = res.obj[0].organName;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0 0.2rem;
}
</style>